module.exports = __webpack_public_path__ + "static/media/control-distancia-rojo.90befb5c.png";